import { LazyLoad } from '@petconsole/pure-fe-mui';

const BusRepairAdmin = LazyLoad(() => import('./BusRepairAdmin'));

export { BusRepairAdmin };
